import { BTable, BFormInput } from "bootstrap-vue";

export default {
  name: "MinFirstOrder",
  components: {
    BTable,
    BFormInput,
  },

  data() {
    return {
      disabled: false,
      url: "admin/customers_club/get_min_first_order",
      editUrl: "admin/customers_club/set_min_first_order",
      items: [],
      min_first_order: null,
    };
  },
  mounted() {
    this.loadData();
  },
  methods: {
    async loadData() {
      this.disabled = true;
      await this.$axios
        .get(this.url)
        .then((res) => {
            console.log(res.data.data.min_first_order,'22');
            this.items = res.data.data.min_first_order;
            this.min_first_order = this.items.value; 
        })
        .catch((err) => {
          this.$root.notify(err);
        })
        .finally(() => {
          this.disabled = false;
        });
    },
    async submitChanges() {
      this.disabled = true;
      await this.$axios
        .post(this.editUrl, { min_value: this.min_first_order })
        .then((res) => {
          this.$root.notify(res.data.message, "success");
        })
        .catch((err) => {
          this.$root.notify(err);
        })
        .finally(() => {
          this.disabled = false;
        });
    },
  },
};
